import { Module } from 'vuex'
import { RootState } from '../types'
import { ABTestingState } from './types'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { state } from './state'

const namespaced = true

export const abtest: Module<ABTestingState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
